/* sugar:assets/blog-post.js@2.0.0 */
/**
 * Blog Post section: table of contents built from the article's headings,
 * the copy-link share button, and the mobile sticky bar the TOC turns into.
 *
 *   [data-bp-toc]         the nav; data-depth "h2"|"h3", data-mobile "sticky"|"inline"
 *   [data-bp-toc-list]    the <ol> the links are written into
 *   [data-bp-toc-toggle]  the tap-to-open bar shown on mobile
 *   [data-bp-content]     the article body the headings are read from
 *   [data-bp-mobile-slot] where the sticky TOC lives on mobile
 *   [data-bp-copy]        copy-link button, value = the URL to copy
 */
(function () {
  'use strict';

  if (window.__swOk === false) return;

  var MOBILE = '(max-width: 749px)';
  var mq = window.matchMedia(MOBILE);

  function slugify(text) {
    return String(text)
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 64) || 'section';
  }

  function ensureIds(headings) {
    var seen = {};
    headings.forEach(function (h) {
      var id = h.id || slugify(h.textContent);
      var base = id;
      var n = 2;
      while (seen[id] || (h.id !== id && document.getElementById(id))) {
        id = base + '-' + n++;
      }
      seen[id] = true;
      h.id = id;
    });
  }

  function buildToc(section) {
    var toc = section.querySelector('[data-bp-toc]');
    var content = section.querySelector('[data-bp-content]');
    if (!toc || !content) return;

    var list = toc.querySelector('[data-bp-toc-list]');
    var selector = toc.dataset.depth === 'h3' ? 'h2, h3' : 'h2';
    var headings = Array.prototype.slice.call(content.querySelectorAll(selector)).filter(function (h) {
      return h.textContent.trim() !== '';
    });

    list.innerHTML = '';
    if (!headings.length) {
      toc.classList.remove('is-populated');
      return;
    }

    ensureIds(headings);

    var links = headings.map(function (h) {
      var li = document.createElement('li');
      li.className = 'sugar-blog-post__toc-item sugar-blog-post__toc-item--' + h.tagName.toLowerCase();
      var a = document.createElement('a');
      a.className = 'sugar-blog-post__toc-link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a);
      list.appendChild(li);
      return a;
    });

    toc.classList.add('is-populated');

    /* Active heading: the last one whose top has passed the sticky line. */
    var ticking = false;
    function offsetLine() {
      var header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      return header + 96;
    }
    function update() {
      ticking = false;
      var line = offsetLine();
      var current = -1;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top - line <= 0) current = i;
      }
      if (current === -1 && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) {
        current = headings.length - 1;
      }
      links.forEach(function (a, i) {
        a.classList.toggle('is-active', i === current);
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    if (toc._bpScroll) window.removeEventListener('scroll', toc._bpScroll);
    toc._bpScroll = onScroll;
    window.addEventListener('scroll', onScroll, { passive: true });
    update();

    /* Tap a link: close the mobile bar. */
    list.addEventListener('click', function (event) {
      var a = event.target.closest('a');
      if (!a) return;
      var toggle = toc.querySelector('[data-bp-toc-toggle]');
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function placeToc(section) {
    var toc = section.querySelector('[data-bp-toc]');
    var slot = section.querySelector('[data-bp-mobile-slot]');
    if (!toc || !slot || toc.dataset.mobile !== 'sticky') return;

    if (!toc._bpHome) {
      toc._bpHome = document.createComment('bp-toc-home');
      toc.parentNode.insertBefore(toc._bpHome, toc);
    }

    if (mq.matches) {
      if (toc.parentNode !== slot) slot.appendChild(toc);
    } else if (toc._bpHome.parentNode && toc.parentNode !== toc._bpHome.parentNode) {
      toc._bpHome.parentNode.insertBefore(toc, toc._bpHome.nextSibling);
    }
  }

  function wireToggle(section) {
    var toggle = section.querySelector('[data-bp-toc-toggle]');
    if (!toggle || toggle._bpWired) return;
    toggle._bpWired = true;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function wireCopy(section) {
    Array.prototype.forEach.call(section.querySelectorAll('[data-bp-copy]'), function (button) {
      if (button._bpWired) return;
      button._bpWired = true;
      button.addEventListener('click', function () {
        var url = button.dataset.bpCopy || window.location.href;
        var done = function () {
          button.classList.add('is-copied');
          window.setTimeout(function () {
            button.classList.remove('is-copied');
          }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done, done);
        } else {
          var input = document.createElement('input');
          input.value = url;
          document.body.appendChild(input);
          input.select();
          try {
            document.execCommand('copy');
          } catch (e) {}
          document.body.removeChild(input);
          done();
        }
      });
    });
  }

  function init(scope) {
    var host = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(host.querySelectorAll('.sugar-blog-post'), function (section) {
      buildToc(section);
      placeToc(section);
      wireToggle(section);
      wireCopy(section);
    });
  }

  function onChange() {
    init(document);
  }
  if (mq.addEventListener) {
    mq.addEventListener('change', onChange);
  } else if (mq.addListener) {
    mq.addListener(onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
    document.addEventListener('shopify:block:select', function (event) {
      init(event.target.closest('.shopify-section') || document);
    });
  }
})();
